module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJKADAAQAAAABAAAAJAAAAAAqDuP8AAAA5ElEQVRYCe2YMQ7CMAxFMeI4HSN15AoVO9eAM8A1uqNegREpY0buEhwpUxX7V0WgDr9b/4tb58et08pu5RFCOGvoYIRPMcbRYK58cKkPu5zzqTVERN4tfYm2XzLon2OYEHKbDtEh5ADirCE6hBxAfHM1JLVrdyjzOdfGelStn+v1/KUN9mkwT06l2w9W1/YiAev1mlayZqhO4rG5JWNC5npVQIeQQ+Upm9bsgX/12AvK2OL6/rppUpcW1wne9avj2mJIYw3RIeQA4qwhOoQcQJw1RIeQA4h/8wctlT2wcYNk6FD+ANmNKhgdoGxcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon-add.png
// module id = RZcp
// module chunks = 39